import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 9a1 1 0 0 1 1 1v1.25h14V10a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-1.25H5V14a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1"
    }, null, -1)
  ])))
}
export default { render: render }